var _rect, _path, _path2, _path3, _g, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_748_1381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_748_1381)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_748_1381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 1,
    width: 14,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4558 8.32647L16.3354 10.9409L14.1083 9.77466L11.6368 4.92766L11.4298 1.28939L16.4705 3.92468L17.4558 8.32647Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7411 5.7749L9.86379 5.64312L7.40763 2.41545L10.1366 1.08808L10.7411 5.7749Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22281 5.44572L7.48212 6.59003L4.18026 5.74559L6.0814 3.29626L8.22281 5.44572Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_748_1381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8623 13.7757L10.0674 13.4847C10.0458 13.0018 9.27792 12.3617 9.57785 11.9813C9.87778 11.6008 10.9701 11.9221 11.4492 11.8172C12.4074 11.6074 13.1821 11.1181 13.7733 10.3492C14.3644 9.58026 14.638 8.70464 14.594 7.72229C14.5447 6.62339 14.1113 5.70021 13.2937 4.95274C12.476 4.20526 11.5178 3.85615 10.4189 3.90541C9.43653 3.94944 8.58889 4.30024 7.87595 4.95783C7.16301 5.61541 6.74494 6.43078 6.62172 7.40394C6.56011 7.89052 6.60199 8.0805 6.00113 8.63296C5.64901 8.96573 5.88652 7.19077 4.63407 7.72238L4.63415 7.1677C4.80158 5.69205 5.42633 4.46285 6.50841 3.48008C7.59049 2.49731 8.86413 1.97308 10.3293 1.90741C11.9943 1.83279 13.4357 2.3521 14.6534 3.46536C15.8712 4.57862 16.5173 5.96774 16.592 7.63274C16.6576 9.09793 16.2495 10.4134 15.3674 11.579C14.4854 12.7447 13.317 13.4769 11.8623 13.7757Z",
    fill: "#3A5F77"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21.4998C10 15.9998 12.5 20.4998 14.3588 14.6202",
    stroke: "#3A5F77",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8651 14.441L14.388 12.8177L16.2819 15.761",
    stroke: "#3A5F77",
    strokeWidth: 2,
    strokeLinecap: "square"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.229684e6c63203c1a29d218a69a75e0f.svg";
export { ForwardRef as ReactComponent };